import { SalesChannelCategoryMappingUpdatePage } from "@/features/sales-channel-category-mapping/pages/SalesChannelCategoryMappingUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-mapping/$id/update",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				// Needs the taxonomy read scope too — the form's GrabMart picker queries it.
				permissions: [
					"sales_channel_category_groups.edit",
					"sales_channel_categories.view",
				],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryMappingUpdatePage,
});
